<template>
    <div>
        <md-button class="md-raised md-dense" @click="writeExcel" style="background-color: aliceblue; margin-top: 20px;">
            Export Data to Excel
        </md-button>
    </div>
</template>

<script>
    import APIRequests from "../APIRequests.js"
    const Excel = require('exceljs');
    import saveAs from "./FileSaver";

    export default {
        props: {
            classroomData: {
                type: Object,
                required: true,
            },
            classroomProfiles: {
                type: Array,
                required: true,
            },
        },
        data() {
            return {
                responseData: {},
                caseNames: {},
            }
        },
        methods: {
            getAllResponses: function(){
                var api_url = this.$store.state.api_url + "/api/classrooms/" + this.classroomData.id + "/responses" 
                return APIRequests.getJSONData(
                    api_url, 
                    this.$store.state.jwtToken
                ).then((data) => {
                    if(!data) data={}
                    this.responseData=data
                })
            },
            getCaseNames: function(){
                var api_url = this.$store.state.api_url + "/api/classrooms/" + this.classroomData.id + "/caseNames" 
                return APIRequests.getJSONData(
                    api_url, 
                    this.$store.state.jwtToken
                ).then((data) => {
                    if(!data) data={}
                    this.caseNames=data
                })
            },
            scoreLearners: function(assignmentID, caseID){
                const caseResponses = this.responseData.filter((resp) => resp.reporting.assignmentID == assignmentID && resp.cid == caseID)
                return this.classroomProfiles.map((profileEntry) => {
                    const firstAttempt = caseResponses.filter(resp => resp.pid == profileEntry.pid && resp.attempt == 1);
                    const timepoints = firstAttempt.map((resp) => resp.finishTime);
                    const firstTimepoint = Math.min(...timepoints)
                    const lastTimepoint = Math.max(...timepoints);
                    const timeOnCase = lastTimepoint - firstTimepoint;
                    // Run over each lab slide in the attempt and add up total spent as well as total possible to spend
                    const vbmScore = firstAttempt.filter((resp) => resp.slideType == "Labs").reduce((agg, resp) => {
                        if(resp.performance.Labs && resp.performance.Labs.totalCost && resp.performance.Labs.maxCost){
                            agg.totalCost += resp.performance.Labs.totalCost;
                            agg.maxCost += resp.performance.Labs.maxCost;
                        }
                        return agg;
                    }, {totalCost: 0, maxCost: 0});
                    // Sum up all scores on labs (determined by missed or unecessary lab purchases) and then take avg.
                    const calcQuestionAvgPct = function(slideType){
                        var totalScore = 0;
                        var totalPct = 0;
                        firstAttempt.forEach((responseElem) => {
                            if(responseElem.performance && Object.keys(responseElem.performance).includes(slideType)){
                                totalScore += responseElem.score
                                totalPct += 100
                            }
                            // Hack to include MC and checklist in knowledge score
                            if(slideType == "Checklist" && responseElem.performance && Object.keys(responseElem.performance).includes("Multiple Choice")){
                                totalScore += responseElem.score
                                totalPct += 100
                            }
                        })
                        return  100 * totalScore / totalPct
                    }
                    const labScore = calcQuestionAvgPct("Labs")
                    const vbmScoreString = `$${vbmScore.totalCost} out of $${vbmScore.maxCost}`
                    const ddxScore = calcQuestionAvgPct("Diagnosis")
                    const knowledgeScore = calcQuestionAvgPct("Checklist")
                    return {
                        fullName: profileEntry.fullName,
                        pid: profileEntry.pid,
                        timeOnCase: isFinite(timeOnCase) ? (timeOnCase ? (timeOnCase / 60).toFixed(1) + " min." : "N/A") : "INCOMPLETE", 
                        vbmScore: vbmScoreString,
                        labScore: labScore ? labScore : "N/A",
                        ddxScore: ddxScore ? ddxScore : "N/A",
                        knowledgeScore: knowledgeScore ? knowledgeScore : "N/A",
                    }
                });
            },
            async writeExcel() {
                await this.getCaseNames()
                await this.getAllResponses()
                const workbook = new Excel.Workbook();
                this.classroomData.assignments.filter((assignment) => assignment.caseList.length > 0).forEach((assignment, i) => {
                    assignment.caseList.forEach((caseID, j) => {
                        const sheet = workbook.addWorksheet(`Assign #${i+1} - Case #${j+1}`);
                        sheet.columns = [
                            { header: 'Name', key: 'fullName', width: 20 },
                            { header: 'Time On Case', key: 'timeOnCase', width: 20},
                            { header: 'VBM Score', key: 'vbmScore', width: 20},
                            { header: 'Lab Score', key: 'labScore', width: 20},
                            { header: 'DDx Score', key: 'ddxScore', width: 20},
                            { header: 'Knowledge Score', key: 'knowledgeScore', width: 20},
                        ];
                        const scoreRows = this.scoreLearners(assignment.id, caseID);
                        sheet.addRows(scoreRows);
                        sheet.spliceRows(1, 0, [])
                        sheet.spliceRows(1, 0, [`${assignment.name} - ${this.caseNames[caseID]}`])
                        sheet.getRow(1).font = { size: 20, bold: true };
                        sheet.getRow(3).font = { bold: true };
                    })
                })
                const buffer = await workbook.xlsx.writeBuffer();
                const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" })
                saveAs(blob, "caseen_classroom_data.xlsx")
            }
        },
    }
</script>